<template>
  <examine-price :not='true'></examine-price>
</template>

<script>
import examinePrice from '../placeOrder/inquire'
export default {
  components: {
    examinePrice
  }
}
</script>

<style>
</style>